import { render, staticRenderFns } from "./swiperTow.vue?vue&type=template&id=020bb78c&scoped=true&"
import script from "./swiperTow.vue?vue&type=script&lang=js&"
export * from "./swiperTow.vue?vue&type=script&lang=js&"
import style0 from "./swiperTow.vue?vue&type=style&index=0&id=020bb78c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020bb78c",
  null
  
)

export default component.exports